import * as Yup from "yup";
import * as Regux from './regux';


export const signInValidation = Yup.object({
  email: Yup.string()
    .required("Please enter email")
    .matches(Regux.email, "Please enter the correct email"),
  password: Yup.string()
    .required("Please enter password")
});

export const forgotPinValidation = Yup.object({
  email: Yup.string()
    .required('Please enter email')
    .matches(Regux.email, "Invalid Email"),
});

export const otpValidation = Yup.object({
  number: Yup.string()
    .min(4)
    .required("Please enter otp"),
})

export const resetPinValidation = Yup.object({
  pin: Yup.string()
    .required('Please enter pin'),
  confirmPin: Yup.string()
    .required('Please enter confirm pin')
    .oneOf([Yup.ref('pin')], 'New Pin and Confirm Pin must be match'),
})

export const changePinValidation = Yup.object({
  oldPin: Yup.string()
    .required('Please enter old pin'),
  newPin: Yup.string()
    .required('Please enter new pin'),
  confirmNewPin: Yup.string()
    .required('Please enter confirm new pin')
    .oneOf([Yup.ref('newPin')], 'New Pin and Confirm New Pin must be match'),
})
export const createPinValidation = Yup.object({
  newPin: Yup.string()
    .required('Please enter new pin'),
  confirmNewPin: Yup.string()
    .required('Please enter confirm new pin')
    .oneOf([Yup.ref('newPin')], 'New Pin and Confirm New Pin must be match'),
})
export const countryValidation = Yup.object({
  code: Yup.string()
    .required("Please enter country code"),
  name: Yup.string()
    .required('Please enter country name')
})
export const promotionalPlanValidation = Yup.object({
  planName: Yup.string()
    .required('Name is required'),
  credit: Yup.number()
   .min(1, 'Credit cannot be negative or zero')
    .required('Credit is required'),
  price: Yup.number()
  .min(0, 'Price cannot be negative')
    .required('Price is required'),
  description: Yup.string()
    .required('Description is required')
})

export const stateValidation = Yup.object({
  code: Yup.string()
    .required("Please enter state code"),
  name: Yup.string()
    .required('Please enter state'),
  countryName: Yup.string()
    .required('Please select country code')
})
export const addRoleValidation = Yup.object({
  title: Yup.string()
    .required("Please enter title"),
  key: Yup.string()
    .required('Please enter key'),
})

export const serviceProviderValidation = Yup.object({
  name: Yup.string()
    .required("Please enter name"),
  providerName: Yup.string().nullable()
    .required("Please enter provider name"),
  mobileNo: Yup.string()
    .required("Please enter mobile number"),
  email: Yup.string()
    .required("Please enter email")
    .matches(Regux.email, "Please enter the correct email")
})

export const editServiceProviderValidation = Yup.object({
  name: Yup.string()
    .required("Please enter name"),
  mobileNo: Yup.string()
    .required("Please enter mobile number"),
  email: Yup.string()
    .required("Please enter email")
    .matches(Regux.email, "Please enter the correct email"),
  businessName: Yup.string()
    .required("Please enter business name")
    .min(3, "Business name must be at least 3 characters"),
  category: Yup.string().nullable()
    .required("Please enter business category"),
  about: Yup.string().nullable()
    .required("Please enter business about"),
})

export const addUserValidation = Yup.object({
  name: Yup.string()
    .required("Please enter name"),
  email: Yup.string()
    .required("Please enter email")
    .matches(Regux.email, "Please enter correct email"),
  // about: Yup.string()
  //   .required("Please enter about"),
  mobileNo: Yup.string()
    .required("Please enter mobile number")
    .matches(Regux.phone, 'Please enter correct mobile number'),
  // businessName: Yup.string()
  //   .required("Please enter business name"),
  // businessCategory: Yup.string()
  //   .required("Please select business category"),
})



export const pricePlanValidation = Yup.object({
  plan_name: Yup.string()
    .required("Please select plan name"),
  description: Yup.string()
    .required("Please enter discription"),
  validity: Yup.string()
    .required("Please select validity"),
  planPrice: Yup.string()
    .required("Please enter plan price"),
  discountType: Yup.string()
    .required("Please select discount type"),
  discountValue: Yup.string()
    .required("Please enter discount value"),
  // finalPrice: Yup.string()
  // .required("Please enter final value")

  // keyName: Yup.string()
  //   .required("Please enter key name")
  // constName: Yup.string()
  //   .required("Please enter const name"),
  // keyValue: Yup.string()
  //   .required("Please enter key value")
})

export const featuresValidation = Yup.object().shape({
  features: Yup.array().of(
    Yup.object().shape({
      keyName: Yup.string().required("Please enter key name ").matches(Regux.whiteSpace, "white space is not required"),
      constName: Yup.string().required("Please enter const name ").matches(Regux.whiteSpace, "white space is not required"),
      keyValue: Yup.string().required("Please enter key value ").matches(Regux.whiteSpace, "white space is not required"),
    })
  ).required('Must have features')
});


// export const timeZoneValidation = Yup.object({
//   code: Yup.string()
//     .required("Please enter code"),
//   name: Yup.string()
//     .required("Please enter name"),
// })


export const promoCodeValidation = Yup.object({
  code: Yup.string()
    .required("Please enter code"),
  title: Yup.string()
    .required("Please enter title"),
  type: Yup.string()
    .required("Please select coupon type"),
  discountType: Yup.string()
    .required("Please select discount type"),
  discountValue: Yup.string()
    .required("Please enter discount value"),
  activeType: Yup.string()
    .required("Please select status type"),
})

export const leadAddValidation = Yup.object({
  name: Yup.string()
    .required("Please enter name")
  ,
  description: Yup.string()
    .required("Please enter description"),
  email: Yup.string()
    .required("Please enter email")
    .matches(Regux.email, "Please enter the correct email"),
  providerName: Yup.string()
    .required("Please enter business name")
  ,
  mobileNo: Yup.string()
    .required("Please enter mobile number")
  ,
  country: Yup.string()
    .required("Please select country")
})
export const validationSchema = Yup.object().shape({
  features: Yup.array().of(
    Yup.object().shape({
      keyName: Yup.string().required('Please enter key name'),
      keyValue: Yup.string().required('Please enter key value'),
      constName: Yup.string().required('Please enter const name'),
    })
  ),
  plan_name: Yup.string()
    .required("Please select plan name"),
  description: Yup.string()
    .required("Please enter description"),
  validity: Yup.string()
    .required("Please select validity"),
  planPrice: Yup.string()
    .required("Please enter plan price"),
});

export const validationAssignPlan = Yup.object().shape({
  // features: Yup.array().of(
  //   Yup.object().shape({
  //     keyName: Yup.string().required('Please enter key name'),
  //     keyValue: Yup.string().required('Please enter key value'),
  //     constName: Yup.string().required('Please enter const name'),
  //   })
  // ),
  validity: Yup.string()
    .required("Please select validity"),
  planPrice: Yup.string()
    .required("Please enter plan price"),
  country: Yup.string()
    .required("Please select country")
});

export const validationAssignPlanFree = Yup.object().shape({
  validity: Yup.string()
    .required("Please enter validity"),
  country: Yup.string()
    .required("Please select country")
});

export const teamAddValidation = Yup.object({
  name: Yup.string()
    .required("Please enter name"),
  email: Yup.string()
    .required("Please enter email")
    .matches(Regux.email, "Please enter the correct email"),
  mobileNo: Yup.string()
    .required("Please enter mobile number"),
})

export const policyAddValidation = Yup.object({
  refundType: Yup.string()
    .required("Please select refund type"),
  validity: Yup.string()
    .required("Please select validity"),
  days: Yup.string()
    .required("Please enter days"),
  cancellationCharge: Yup.string()
    .required("Please enter cancellation charge"),
})
export const durationValidation = Yup.object({
  duration: Yup.string().required('Please select duration')
})


export const groupAddValidation = Yup.object({
  name: Yup.string()
    .required("Please enter group name"),
  contact: Yup.array()
    .min(1, "Please select contact"),
  description: Yup.string()
    .required("Please enter description"),
})